<template>
  <v-dialog
    v-model="value"
    width="400"
    persistent>
    <v-card>
      <v-container
        fluid
        >
        <v-row
          justify=center>
          <v-col
            class="error--text main--text"
            cols=auto>
            {{ message }}
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=auto>
            <v-btn
              depressed
              outlined
              rounded
              color="primary"
              class="main--text"
              @click="$emit('input', false)">OK</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props:{
    value: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      default: "予期せぬエラーが発生しました。"
    }
  }
}
</script>

<style scoped>
.error--text {
  color: red;
  font-weight: bold;
}
</style>
